import { api } from '../utils/api';

export interface PaymentDetailItem {
  method: string;
  amount: number;
  received?: number;
  change?: number;
  tip?: number;
  reference?: string;
}

export interface CreatePaymentPayload {
  orderId: string | number;
  tableId: string | number;
  cashRegisterId: string | number;
  amount?: number;
  method?: string;
  received?: number;
  change?: number;
  tip?: number;
  reference?: string;
  payments?: PaymentDetailItem[];
}

export async function createPayment(payload: CreatePaymentPayload) {
  const { data } = await api.post('/payments', payload);
  return data;
}
